export default __webpack_public_path__ + "c40ec6b67012b4113aacc3cc90a6450b.png";